import {List, Map} from 'immutable';
import {memoize} from '../../lib/memoizer';

import type {OrderedMap} from 'immutable';

type Memoizer = <T>(key: string, func: () => T) => T;

interface GenericListCollection extends List<any> {
  cache: Memoizer;
  getCollection: () => List<any>;
  asMap: () => Map<unknown, unknown>;
}

interface GenericMapCollection extends Map<unknown, unknown> {
  cache: Memoizer;
  getCollection: () => Map<unknown, unknown>;
}

export function GenericListCollectionModel(data?: List<any> | null): List<any> {
  const collection = (data ? List(data) : List()) as GenericListCollection;
  collection.cache = memoize();
  collection.getCollection = () => collection;
  collection.asMap = () =>
    collection.cache('asMap', () => {
      return collection.reduce<Map<unknown, unknown>>((acc, val) => {
        return acc!.set(val.getId(), val);
      }, Map());
    });
  return collection;
}

 
(Map.prototype as any).sorted = function(
  sortFn: (value: Map<unknown, unknown>) => Map<unknown, unknown>
): OrderedMap<unknown, unknown> {
  return this.cache(sortFn.toString(), () => this.sortBy(sortFn));
};
 

export function GenericMapCollectionModel(
  data: List<any>,
  fromServer: boolean = false
): Map<unknown, unknown> {
  const collection = Map(
    fromServer ? data.toMap().mapKeys((key, val) => val.get('id')) : data
  ) as GenericMapCollection;
  collection.cache = memoize();
  collection.getCollection = () => collection;
  return collection;
}
